import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

function Stars({ rating }): React.ReactElement {
  const stars = rating ? new Array(Math.floor(rating)).fill('*') : [];
  return stars ? (
    <div>
      <div>
        {stars.map((item, index) => (
          <span key={index} className="mb-6 mr">
            <StaticImage src="../../images/favorite.png" alt="difficulty" width={30} />
          </span>
        ))}
      </div>
    </div>
  ) : (
    <></>
  );
}

export { Stars };
